var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 3.49568C14.3299 3.19597 13.2226 3 12 3C6.4752 3 2 7.47262 2 12.9942C2 18.5274 6.4752 23 12 23C17.5248 23 22 18.5274 22 13.0058C22 10.9539 21.3772 9.04035 20.316 7.44957",
    stroke: "#525455",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L14 1",
    stroke: "#525455",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L14 5",
    stroke: "#525455",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.4662V12.5338C7 11.9829 7.42479 11.5274 7.94953 11.5274C8.85407 11.5274 9.22389 10.8493 8.76912 10.0177C8.50925 9.54091 8.66417 8.92114 9.11894 8.64568L9.98351 8.12125C10.3783 7.87228 10.8881 8.02061 11.1229 8.43909L11.1779 8.53974C11.6277 9.3714 12.3673 9.3714 12.8221 8.53974L12.8771 8.43909C13.1119 8.02061 13.6217 7.87228 14.0165 8.12125L14.8811 8.64568C15.3358 8.92114 15.4908 9.54091 15.2309 10.0177C14.7761 10.8493 15.1459 11.5274 16.0505 11.5274C16.5702 11.5274 17 11.9776 17 12.5338V13.4662C17 14.0171 16.5752 14.4726 16.0505 14.4726C15.1459 14.4726 14.7761 15.1507 15.2309 15.9823C15.4908 16.4644 15.3358 17.0789 14.8811 17.3543L14.0165 17.8787C13.6217 18.1277 13.1119 17.9794 12.8771 17.5609L12.8221 17.4603C12.3723 16.6286 11.6327 16.6286 11.1779 17.4603L11.1229 17.5609C10.8881 17.9794 10.3783 18.1277 9.98351 17.8787L9.11894 17.3543C8.66417 17.0789 8.50925 16.4591 8.76912 15.9823C9.22389 15.1507 8.85407 14.4726 7.94953 14.4726C7.42479 14.4726 7 14.0171 7 13.4662Z",
    stroke: "#525455",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z",
    stroke: "#525455",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.b11c90941c07cfb5440e96ecc0c94327.svg";
export { ForwardRef as ReactComponent };